import { Skeleton } from "@mui/material";

function BandBadgeSkeleton({ width = 72 }: { width?: number }) {
  return (
    <Skeleton
      variant="rounded"
      width={width}
      height={22}
      sx={{ borderRadius: "16px" }}
    />
  );
}

export default BandBadgeSkeleton;
